export default "__VITE_ASSET__DpNYEVxS__"